import { App, ConfigProvider } from "antd";
import { ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { buildAntdTheme } from "./antdTheme";
import { ThemeModeProvider, useThemeMode } from "./ThemeModeContext";

function AntdThemeBridge({ children }: { children: ReactNode }) {
  const { resolved } = useThemeMode();
  const { i18n } = useTranslation();
  // i18n.language, not resolvedLanguage: resolvedLanguage falls back to "en" when the Thai bundle isn't loaded yet.
  const thai = (i18n.language ?? "").toLowerCase().startsWith("th");
  const config = useMemo(() => buildAntdTheme(resolved, { thai }), [resolved, thai]);
  return (
    <ConfigProvider theme={config}>
      <App notification={{ placement: "topRight" }}>{children}</App>
    </ConfigProvider>
  );
}

interface IThemeProviderProps {
  children: ReactNode | ReactNode[];
}

/** Theme choice (System / Light / Dark) plus the antd theme for the resolved mode. */
const ThemeProvider = ({ children }: IThemeProviderProps) => (
  <ThemeModeProvider>
    <AntdThemeBridge>{children}</AntdThemeBridge>
  </ThemeModeProvider>
);

export default ThemeProvider;
